<ng-container *ngIf="user">
  <h2 mat-dialog-title class="label-text">
    {{ user.name }}, {{ (data.type === 'end' ? 'ClockIn.EndJourney' : 'ClockIn.StartJourney') | translate }}
  </h2>
</ng-container>
<div mat-dialog-actions>
  <button type="button" [mat-dialog-close]="true" translate>&nbsp;General.Yes&nbsp;</button>
  <button type="button" [mat-dialog-close]="false" class="ml-2 light" translate>General.No</button>
</div>
